import React from "react";
import "./AboutPassion.css";
import Gfooter from "../Component/Gfooter";

function AboutMission() {
  return (
    <>
      <section className="vision-section">

        {/* 🔥 HERO SECTION */}
        <div className="vision-hero">
          <div className="container">
            <div className="row align-items-center">

              <div className="col-lg-6">
                <h1 data-aos="fade-right">Our Passion</h1>
                <p data-aos="fade-right" data-aos-delay="200">
                   To Expand Business Reach, Improve Sales Conversion And
                      Have Enduring Client Relationships By Harnessing Cutting
                      Edge Technology And Leveraging Our Key Technology.
                </p>
              </div>

              <div className="col-lg-6 text-center">
                <img
                  src="about-img/passionnew.jpg"
                  alt="vision"
                  className="img-fluid vision-img"
                  data-aos="zoom-in"
                />
              </div>

            </div>
          </div>
        </div>

        {/* 💡 CONTENT SECTION */}
        <div className="vision-content container">
          <div className="row">

            <div className="col-md-4" data-aos="fade-up">
              <div className="vision-card">
                <h4>Innovation</h4>
                <p>
                  Continuously evolving with modern technology to provide
                  cutting-edge solutions.
                </p>
              </div>
            </div>

            <div className="col-md-4" data-aos="fade-up" data-aos-delay="200">
              <div className="vision-card">
                <h4>Trust</h4>
                <p>
                  Building long-term relationships with transparency and
                  commitment.
                </p>
              </div>
            </div>

            <div className="col-md-4" data-aos="fade-up" data-aos-delay="400">
              <div className="vision-card">
                <h4>Excellence</h4>
                <p>
                  Delivering high-quality solutions that exceed expectations.
                </p>
              </div>
            </div>

          </div>
        </div>

        {/* 🎯 QUOTE SECTION */}
        <div className="vision-quote text-center">
          <h3 data-aos="zoom-in">
            "Empowering businesses through technology and innovation"
          </h3>
        </div>

      </section>

      <Gfooter />
    </>
  );
}

export default AboutMission;